import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import { compose } from "recompose";
import { resendUserInvitation } from "../../../redux/actions";

const ResendInvitationMenuItem = ({ intl, subscriber, onComplete }) => {
  const dispatch = useDispatch();
  const onClick = () => {
    if (onComplete) {
      onComplete();
    }

    dispatch(resendUserInvitation(subscriber.email));
  };

  return (
    <MenuItem
      onClick={() => {
        onClick();
      }}
    >
      {intl.formatMessage({
        id: "app.subscribers.resendInvitationMenuItemText",
      })}
    </MenuItem>
  );
};

const enhance = compose(injectIntl);

export default enhance(ResendInvitationMenuItem);
